import React, { useEffect } from "react"
import Header from "../components/Header"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const PromoOver: React.FC = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/promoOver-desktop.jpg"} />
					<img src={"/images/promoOver-mobile.jpg"} className=" block w-full" alt="Danke" />
				</picture>
			</div>
			<div className="text-center pt-4 sm:pt-0">
				<h2 className="h2 text-yellow font-Fields text-[30px] sm:text-[49px] max-w-[805px] mx-auto leading-tight">
					Vielen Dank an alle, die an unserer Aktion teilgenommen haben.
				</h2>
				<p className="font-AcuminWide text-[14px] sm:text-[18px]  mt-4 sm:mt-7 leading-[2.0] max-w-[905px] mx-auto px-4">
					Du hast noch Fragen zur Aktion? Kein Problem! <br />
					Kontaktiere uns einfach per E-Mail unter{" "}
					<a href="mailto:wilkinsons@gewinnspiel-2026.de" className="underline">
						wilkinsons@gewinnspiel-2026.de
					</a>
					.
					<br /> Besuche uns gerne auf{" "}
					<a href="https://www.wilkinsonsword.de/" target="_blank" className="underline">
						www.wilkinsonsword.de
					</a>
					, um nichts zu verpassen.
				</p>

				<div className="pb-20 sm:pb-12 pt-12 text-center">
					<a href="https://www.wilkinsonsword.de/" target="_blank" className="btn btn-yellow">
						Zur Wilkinson Website
					</a>
				</div>
			</div>
		</>
	)
}
export default PromoOver
